"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrantPermissionsDialog = exports.GRANT_ACCESS_BUTTON_TESTID = exports.MANAGE_PERMISSIONS_BUTTON_TESTID = exports.DISMISS_BUTTON_TESTID = exports.GRANT_ACCESS_TESTID = exports.AuthorizableType = void 0;
var React = require("react");
var styles = require("../../styles/GrantPermissionsDialogStyle");
var widgets_1 = require("@tableau/widgets");
var Localize_1 = require("../../../gen-src/Localize");
var StringInterpolation_1 = require("../../utils/StringInterpolation");
var Notification_1 = require("../../utils/Notification");
var ApiService_1 = require("../../server/ApiService");
var TelemetryService_1 = require("../../utils/TelemetryService");
var AuthorizableType;
(function (AuthorizableType) {
    AuthorizableType["COLLECTION"] = "collection";
    AuthorizableType["DATABASE"] = "database";
    AuthorizableType["DATABASE_TABLE_TEMPLATE"] = "databaseTableTemplate";
    AuthorizableType["DATAROLE"] = "dataRole";
    AuthorizableType["DATASOURCE"] = "datasource";
    AuthorizableType["FLOW"] = "flow";
    AuthorizableType["LENS"] = "lens";
    AuthorizableType["METRIC"] = "metric";
    AuthorizableType["PREDICTIVE_MODEL"] = "predictiveModel";
    AuthorizableType["PROJECT"] = "project";
    AuthorizableType["PROJECT_DATASOURCE_TEMPLATE"] = "projectDatasourceTemplate";
    AuthorizableType["PROJECT_DATA_ROLE_TEMPLATE"] = "projectDataRoleTemplate";
    AuthorizableType["PROJECT_LENS_TEMPLATE"] = "projectLensTemplate";
    AuthorizableType["PROJECT_FLOW_TEMPLATE"] = "projectFlowTemplate";
    AuthorizableType["PROJECT_METRIC_TEMPLATE"] = "projectMetricTemplate";
    AuthorizableType["PROJECT_PREDICTIVE_MODEL_TEMPLATE"] = "projectPredictiveModelTemplate";
    AuthorizableType["PROJECT_PUBLISHED_CONNECTION_TEMPLATE"] = "projectPublishedConnectionTemplate";
    AuthorizableType["PROJECT_WORKBOOK_TEMPLATE"] = "projectWorkbookTemplate";
    AuthorizableType["PROJECT_DATABASE_TEMPLATE"] = "projectDatabaseTemplate";
    AuthorizableType["PROJECT_TABLE_TEMPLATE"] = "projectTableTemplate";
    AuthorizableType["PUBLISHED_CONNECTION"] = "virtualConnection";
    AuthorizableType["TABLE"] = "table";
    AuthorizableType["VIEW"] = "view";
    AuthorizableType["WORKBOOK"] = "workbook";
})(AuthorizableType = exports.AuthorizableType || (exports.AuthorizableType = {}));
exports.GRANT_ACCESS_TESTID = 'collection-grant-access';
exports.DISMISS_BUTTON_TESTID = exports.GRANT_ACCESS_TESTID + '-dismiss';
exports.MANAGE_PERMISSIONS_BUTTON_TESTID = exports.GRANT_ACCESS_TESTID + '-manage-permissions';
exports.GRANT_ACCESS_BUTTON_TESTID = exports.GRANT_ACCESS_TESTID + '-grant-access';
var ContentTypeToMessagesMap = new Map()
    .set('collection', {
    shareOneUser: Localize_1.Messages.shareGrantPermissionsDialogSharedWithOneUserMessage_collection,
    shareMultipleUsers: Localize_1.Messages.shareGrantPermissionsDialogMessage_collection,
    shareOneUserLocked: function () { return ''; },
    shareOneUserLockedWorkbook: function () { return ''; },
    shareMultipleUsersLocked: function () { return ''; },
    shareMultipleUsersLockedWorkbook: function () { return ''; },
    permissionsTemplate: function () { return ''; },
    dialogHeader: function () { return ''; },
    dialogHeaderLocked: function () { return ''; },
    dialogHeaderLockedWorkbook: function () { return ''; },
    dialogTitle: Localize_1.Messages.shareGrantPermissionsDialogTitle_collection,
    requestAccess: Localize_1.Messages.requestAccessDescription,
})
    .set('datasource', {
    shareOneUser: Localize_1.Messages.shareGrantPermissionsDialogSharedWithOneUserMessage_datasource,
    shareMultipleUsers: Localize_1.Messages.shareGrantPermissionsDialogMessage_datasource,
    shareOneUserLocked: Localize_1.Messages.shareGrantPermissionsDialogSharedWithOneUserMessage_lockedProject_datasource,
    shareOneUserLockedWorkbook: function () { return ''; },
    shareMultipleUsersLocked: Localize_1.Messages.shareGrantPermissionsDialogMessage_lockedProject_datasource,
    shareMultipleUsersLockedWorkbook: function () { return ''; },
    dialogTitle: Localize_1.Messages.shareGrantPermissionsDialogTitle_datasource,
    dialogHeader: Localize_1.Messages.shareGrantPermissionDialogHeader_datasource,
    dialogHeaderLocked: Localize_1.Messages.shareGrantPermissionDialogHeader_lockedProject_datasource,
    dialogHeaderLockedWorkbook: function () { return ''; },
    permissionsTemplate: Localize_1.Messages.shareGrantPermissionsDialogTemplateDescription_datasource,
    requestAccess: Localize_1.Messages.requestAccessDescription,
})
    .set('flow', {
    shareOneUser: Localize_1.Messages.shareGrantPermissionsDialogSharedWithOneUserMessage_flow,
    shareMultipleUsers: Localize_1.Messages.shareGrantPermissionsDialogMessage_flow,
    shareOneUserLocked: Localize_1.Messages.shareGrantPermissionsDialogSharedWithOneUserMessage_lockedProject_flow,
    shareOneUserLockedWorkbook: function () { return ''; },
    shareMultipleUsersLocked: Localize_1.Messages.shareGrantPermissionsDialogMessage_lockedProject_flow,
    shareMultipleUsersLockedWorkbook: function () { return ''; },
    dialogTitle: Localize_1.Messages.shareGrantPermissionsDialogTitle_datasource,
    dialogHeader: Localize_1.Messages.shareGrantPermissionDialogHeader_flow,
    dialogHeaderLocked: Localize_1.Messages.shareGrantPermissionDialogHeader_lockedProject_flow,
    dialogHeaderLockedWorkbook: function () { return ''; },
    permissionsTemplate: Localize_1.Messages.shareGrantPermissionsDialogTemplateDescription_flow,
    requestAccess: Localize_1.Messages.requestAccessDescription,
})
    .set('metric', {
    shareOneUser: Localize_1.Messages.shareGrantPermissionsDialogSharedWithOneUserMessage_metric,
    shareMultipleUsers: Localize_1.Messages.shareGrantPermissionsDialogMessage_metric,
    shareOneUserLocked: Localize_1.Messages.shareGrantPermissionsDialogSharedWithOneUserMessage_lockedProject_metric,
    shareOneUserLockedWorkbook: function () { return ''; },
    shareMultipleUsersLocked: Localize_1.Messages.shareGrantPermissionsDialogMessage_lockedProject_metric,
    shareMultipleUsersLockedWorkbook: function () { return ''; },
    dialogTitle: Localize_1.Messages.shareGrantPermissionsDialogTitle_metric,
    dialogHeader: Localize_1.Messages.shareGrantPermissionDialogHeader_metric,
    dialogHeaderLocked: Localize_1.Messages.shareGrantPermissionDialogHeader_lockedProject_metric,
    dialogHeaderLockedWorkbook: function () { return ''; },
    permissionsTemplate: Localize_1.Messages.shareGrantPermissionsDialogTemplateDescription_metric,
    requestAccess: Localize_1.Messages.requestAccessDescription,
})
    .set('virtualConnection', {
    shareOneUser: Localize_1.Messages.shareGrantPermissionsDialogSharedWithOneUserMessage_virtualConnection,
    shareMultipleUsers: Localize_1.Messages.shareGrantPermissionsDialogMessage_virtualConnection,
    shareOneUserLocked: Localize_1.Messages.shareGrantPermissionsDialogSharedWithOneUserMessage_lockedProject_virtualConnection,
    shareOneUserLockedWorkbook: function () { return ''; },
    shareMultipleUsersLocked: Localize_1.Messages.shareGrantPermissionsDialogMessage_lockedProject_virtualConnection,
    shareMultipleUsersLockedWorkbook: function () { return ''; },
    dialogTitle: Localize_1.Messages.shareGrantPermissionsDialogTitle_virtualConnection,
    dialogHeader: Localize_1.Messages.shareGrantPermissionDialogHeader_virtualConnection,
    dialogHeaderLocked: Localize_1.Messages.shareGrantPermissionDialogHeader_lockedProject_virtualConnection,
    dialogHeaderLockedWorkbook: function () { return ''; },
    permissionsTemplate: Localize_1.Messages.shareGrantPermissionsDialogTemplateDescription_virtualConnection,
    requestAccess: Localize_1.Messages.requestAccessDescription,
})
    .set('project', {
    shareOneUser: Localize_1.Messages.shareGrantPermissionsDialogSharedWithOneUserMessage_project,
    shareMultipleUsers: Localize_1.Messages.shareGrantPermissionsDialogMessage_project,
    shareOneUserLocked: Localize_1.Messages.shareGrantPermissionsDialogSharedWithOneUserMessage_lockedProject_project,
    shareOneUserLockedWorkbook: function () { return ''; },
    shareMultipleUsersLocked: Localize_1.Messages.shareGrantPermissionsDialogMessage_lockedProject_project,
    shareMultipleUsersLockedWorkbook: function () { return ''; },
    dialogTitle: Localize_1.Messages.shareGrantPermissionsDialogTitle_project,
    dialogHeader: Localize_1.Messages.shareGrantPermissionDialogHeader_project,
    dialogHeaderLocked: Localize_1.Messages.shareGrantPermissionDialogHeader_lockedProject_project,
    dialogHeaderLockedWorkbook: function () { return ''; },
    permissionsTemplate: Localize_1.Messages.shareGrantPermissionsDialogTemplateDescription_project,
    requestAccess: Localize_1.Messages.requestAccessDescription,
})
    .set('view', {
    shareOneUser: Localize_1.Messages.shareGrantPermissionsDialogSharedWithOneUserMessage_view,
    shareMultipleUsers: Localize_1.Messages.shareGrantPermissionsDialogMessage_view,
    shareOneUserLocked: Localize_1.Messages.shareGrantPermissionsDialogSharedWithOneUserMessage_lockedProject_view,
    shareOneUserLockedWorkbook: Localize_1.Messages.shareGrantPermissionsDialogSharedWithOneUserMessage_lockedWorkbook_view,
    shareMultipleUsersLocked: Localize_1.Messages.shareGrantPermissionsDialogMessage_lockedProject_view,
    shareMultipleUsersLockedWorkbook: Localize_1.Messages.shareGrantPermissionsDialogMessage_lockedWorkbook_view,
    dialogTitle: Localize_1.Messages.shareGrantPermissionsDialogTitle_view,
    dialogHeader: Localize_1.Messages.shareGrantPermissionDialogHeader_view,
    dialogHeaderLocked: Localize_1.Messages.shareGrantPermissionDialogHeader_lockedProject_view,
    dialogHeaderLockedWorkbook: Localize_1.Messages.shareGrantPermissionDialogHeader_lockedWorkbook_view,
    permissionsTemplate: Localize_1.Messages.shareGrantPermissionsDialogTemplateDescription_view,
    requestAccess: Localize_1.Messages.requestAccessDescription,
})
    .set('workbook', {
    shareOneUser: Localize_1.Messages.shareGrantPermissionsDialogSharedWithOneUserMessage_workbook,
    shareMultipleUsers: Localize_1.Messages.shareGrantPermissionsDialogMessage_workbook,
    shareOneUserLocked: Localize_1.Messages.shareGrantPermissionsDialogSharedWithOneUserMessage_lockedProject_workbook,
    shareOneUserLockedWorkbook: function () { return ''; },
    shareMultipleUsersLocked: Localize_1.Messages.shareGrantPermissionsDialogMessage_lockedProject_workbook,
    shareMultipleUsersLockedWorkbook: function () { return ''; },
    dialogTitle: Localize_1.Messages.shareGrantPermissionsDialogTitle_workbook,
    dialogHeader: Localize_1.Messages.shareGrantPermissionDialogHeader_workbook,
    dialogHeaderLocked: Localize_1.Messages.shareGrantPermissionDialogHeader_lockedProject_workbook,
    dialogHeaderLockedWorkbook: function () { return ''; },
    permissionsTemplate: Localize_1.Messages.shareGrantPermissionsDialogTemplateDescription_workbook,
    requestAccess: Localize_1.Messages.requestAccessDescription,
});
var ContentTypeToTemplateType = new Map([
    ['datasource', AuthorizableType.PROJECT_DATASOURCE_TEMPLATE],
    ['flow', AuthorizableType.PROJECT_FLOW_TEMPLATE],
    ['metric', AuthorizableType.PROJECT_METRIC_TEMPLATE],
    ['virtualConnection', AuthorizableType.PROJECT_PUBLISHED_CONNECTION_TEMPLATE],
    ['project', AuthorizableType.PROJECT],
    ['view', AuthorizableType.PROJECT_WORKBOOK_TEMPLATE],
    ['workbook', AuthorizableType.PROJECT_WORKBOOK_TEMPLATE],
]);
var GrantPermissionsDialog = /** @class */ (function (_super) {
    __extends(GrantPermissionsDialog, _super);
    function GrantPermissionsDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderBoldLockedProject = function () { return (React.createElement("span", { style: { fontWeight: 'bold', } }, Localize_1.Messages.shareGrantPermissionsDialogMessageLockedPermissions())); };
        _this.renderBoldTabbedWorkbook = function () { return (React.createElement("span", { style: { fontWeight: 'bold', } }, Localize_1.Messages.shareGrantPermissionsDialogMessageTabbedViews())); };
        _this.handleGrantPermissions = function () {
            var authorizable = { type: _this.props.content.type, id: _this.props.content.id.toString() };
            if (_this.props.sourceAuthorizable !== undefined) {
                if (_this.props.sourceAuthorizable.type === 'project') {
                    authorizable = { type: ContentTypeToTemplateType.get(_this.props.content.type), id: _this.props.sourceAuthorizable.id.toString() };
                }
                else if (_this.props.sourceAuthorizable.type === 'workbook') {
                    authorizable = { type: _this.props.sourceAuthorizable.type, id: _this.props.sourceAuthorizable.id.toString() };
                }
            }
            var onSuccess = function () {
                Notification_1.Notification.Instance.showInfo(Localize_1.Messages.shareGrantPermissionsDialogGrantSuccessMsg({
                    USER_COUNT: _this.props.unpermissionedRecipients.length,
                    USER_COUNT_LOC: Localize_1.Formatters.formatCount(_this.props.unpermissionedRecipients.length)
                }));
                _this.props.grantAccessHandler();
            };
            var showErrorNotification = function () {
                Notification_1.Notification.Instance.showError(Localize_1.Messages.shareGrantPermissionsDialogGrantErrorMsg({
                    USER_COUNT: _this.props.unpermissionedRecipients.length,
                    USER_COUNT_LOC: Localize_1.Formatters.formatCount(_this.props.unpermissionedRecipients.length)
                }));
                _this.props.grantAccessHandler();
            };
            var authorizableGranteePermissionsList = _this.props.unpermissionedRecipients.map(function (grantee) {
                return { authorizable: authorizable, grantee: grantee, permissions: _this.props.capabilities, };
            });
            ApiService_1.ApiService.setExplicitPermissions(authorizableGranteePermissionsList)
                .then(onSuccess, showErrorNotification);
        };
        _this.onCancel = function () {
            _this.props.dismissHandler();
        };
        return _this;
    }
    GrantPermissionsDialog.prototype.componentDidMount = function () {
        // Initialize dialog notification with the external module's toast handler
        if (this.props.toastHandler) {
            Notification_1.Notification.Instance.init(this.props.toastHandler);
        }
        // Initialize telemetry logger
        if (this.props.logEvent) {
            TelemetryService_1.TelemetryService.Instance.initLogEvent(this.props.logEvent);
        }
    };
    GrantPermissionsDialog.prototype.renderContents = function () {
        if (this.props.content.type !== 'collection') {
            var grantPermissionHeader = void 0;
            var grantPermissionMessage = void 0;
            var messages = ContentTypeToMessagesMap.get(this.props.content.type);
            if (messages !== undefined) {
                grantPermissionHeader = messages.dialogHeader({ CONTENT_NAME: this.props.content.name });
                if (this.props.shareRecipients.length === 1) {
                    grantPermissionHeader = messages.dialogHeader({ CONTENT_NAME: this.props.content.name });
                    if (this.props.sourceAuthorizable === undefined) {
                        grantPermissionHeader = messages.dialogHeader({ CONTENT_NAME: this.props.content.name });
                        if (this.props.userRequestedAccess) {
                            grantPermissionMessage = messages.requestAccess({ USER_FRIENDLY_NAME: this.props.requesterName, CONTENT_NAME: this.props.content.name });
                        }
                        else {
                            grantPermissionMessage = messages.shareOneUser({ CONTENT_NAME: this.props.content.name });
                        }
                    }
                    else if (this.props.sourceAuthorizable.type === 'project') {
                        grantPermissionHeader = messages.dialogHeaderLocked({ PROJECT_NAME: this.props.sourceAuthorizable.name });
                        if (this.props.userRequestedAccess) {
                            grantPermissionMessage = messages.requestAccess({ USER_FRIENDLY_NAME: this.props.requesterName, CONTENT_NAME: this.props.content.name });
                        }
                        else {
                            grantPermissionMessage = StringInterpolation_1.interpolateString(messages.shareOneUserLocked({ CONTENT_NAME: this.props.content.name }), { LOCKED_PERMISSIONS: this.renderBoldLockedProject() });
                        }
                    }
                    else if (this.props.sourceAuthorizable.type === 'workbook') {
                        grantPermissionHeader = messages.dialogHeaderLockedWorkbook({ WORKBOOK_NAME: this.props.sourceAuthorizable.name });
                        if (this.props.userRequestedAccess) {
                            grantPermissionMessage = messages.requestAccess({ USER_FRIENDLY_NAME: this.props.requesterName, CONTENT_NAME: this.props.content.name });
                        }
                        else {
                            grantPermissionMessage = StringInterpolation_1.interpolateString(messages.shareOneUserLockedWorkbook({ CONTENT_NAME: this.props.content.name }), { TABBED_VIEWS: this.renderBoldTabbedWorkbook() });
                        }
                    }
                }
                else {
                    if (this.props.sourceAuthorizable === undefined) {
                        grantPermissionHeader = messages.dialogHeader({ CONTENT_NAME: this.props.content.name });
                        grantPermissionMessage = messages.shareMultipleUsers({
                            CONTENT_NAME: this.props.content.name,
                            TOTAL_USER_COUNT: this.props.shareRecipients.length,
                            TOTAL_USER_COUNT_LOC: Localize_1.Formatters.formatCount(this.props.shareRecipients.length),
                            UNPERMISSIONED_USER_COUNT: this.props.unpermissionedRecipients.length,
                            UNPERMISSIONED_USER_COUNT_LOC: Localize_1.Formatters.formatCount(this.props.unpermissionedRecipients.length),
                        });
                    }
                    else if (this.props.sourceAuthorizable.type === 'project') {
                        grantPermissionHeader = messages.dialogHeaderLocked({ PROJECT_NAME: this.props.sourceAuthorizable.name });
                        grantPermissionMessage = StringInterpolation_1.interpolateString(messages.shareMultipleUsersLocked({
                            CONTENT_NAME: this.props.content.name,
                            TOTAL_USER_COUNT: this.props.shareRecipients.length,
                            TOTAL_USER_COUNT_LOC: Localize_1.Formatters.formatCount(this.props.shareRecipients.length),
                            UNPERMISSIONED_USER_COUNT: this.props.unpermissionedRecipients.length,
                            UNPERMISSIONED_USER_COUNT_LOC: Localize_1.Formatters.formatCount(this.props.unpermissionedRecipients.length),
                        }), { LOCKED_PERMISSIONS: this.renderBoldLockedProject() });
                    }
                    else if (this.props.sourceAuthorizable.type === 'workbook') {
                        grantPermissionHeader = messages.dialogHeaderLockedWorkbook({ WORKBOOK_NAME: this.props.sourceAuthorizable.name });
                        grantPermissionMessage = StringInterpolation_1.interpolateString(messages.shareMultipleUsersLockedWorkbook({
                            CONTENT_NAME: this.props.content.name,
                            TOTAL_USER_COUNT: this.props.shareRecipients.length,
                            TOTAL_USER_COUNT_LOC: Localize_1.Formatters.formatCount(this.props.shareRecipients.length),
                            UNPERMISSIONED_USER_COUNT: this.props.unpermissionedRecipients.length,
                            UNPERMISSIONED_USER_COUNT_LOC: Localize_1.Formatters.formatCount(this.props.unpermissionedRecipients.length),
                        }), { TABBED_VIEWS: this.renderBoldTabbedWorkbook });
                    }
                }
                return (React.createElement("div", { style: { fontWeight: 'normal', fontSize: '12px', lineHeight: '18px', color: '#4F4F4F', letterSpacing: '0.2px' } },
                    React.createElement("h3", { style: { fontWeight: 'normal', color: '#000000', marginTop: '0' } }, grantPermissionHeader),
                    grantPermissionMessage,
                    React.createElement("div", null,
                        React.createElement("br", null),
                        messages.permissionsTemplate())));
            }
        }
        return (React.createElement("div", { style: { fontWeight: 'normal', fontSize: '12px', lineHeight: '18px', color: '#4F4F4F', letterSpacing: '0.2px' } },
            this.props.shareRecipients.length === 1 &&
                Localize_1.Messages.shareGrantPermissionsDialogSharedWithOneUserMessage_collection({
                    CONTENT_NAME: this.props.content.name
                }),
            this.props.shareRecipients.length !== 1 &&
                Localize_1.Messages.shareGrantPermissionsDialogMessage_collection({
                    CONTENT_NAME: this.props.content.name,
                    TOTAL_USER_COUNT: this.props.shareRecipients.length,
                    TOTAL_USER_COUNT_LOC: Localize_1.Formatters.formatCount(this.props.shareRecipients.length),
                    UNPERMISSIONED_USER_COUNT: this.props.unpermissionedRecipients.length,
                    UNPERMISSIONED_USER_COUNT_LOC: Localize_1.Formatters.formatCount(this.props.unpermissionedRecipients.length)
                })));
    };
    GrantPermissionsDialog.prototype.renderFooter = function () {
        return (React.createElement("div", { style: styles.footer },
            React.createElement("span", { style: styles.managePermissionsButton }, this.props.managePermissionsHandler &&
                React.createElement(widgets_1.ButtonWidget, { onClick: this.props.managePermissionsHandler, buttonType: widgets_1.ButtonType.LowEmphasis, children: Localize_1.Messages.shareGrantPermissionsDialogManagePermissionsAction(), testId: exports.MANAGE_PERMISSIONS_BUTTON_TESTID })),
            React.createElement("span", { style: styles.rightButtons },
                React.createElement("div", { style: { paddingLeft: widgets_1.TabStyles.Spacing.MediumSpace } },
                    React.createElement(widgets_1.ButtonWidget, { handleClick: this.onCancel, buttonType: widgets_1.ButtonType.Outline, children: Localize_1.Messages.shareGrantPermissionsDialogDismiss(), testId: exports.DISMISS_BUTTON_TESTID })),
                React.createElement("div", { style: { paddingLeft: widgets_1.TabStyles.Spacing.MediumSpace } },
                    React.createElement(widgets_1.ButtonWidget, { handleClick: this.handleGrantPermissions, buttonType: widgets_1.ButtonType.Primary, children: Localize_1.Messages.shareGrantPermissionsDialogGrantAccess(), testId: exports.GRANT_ACCESS_BUTTON_TESTID })))));
    };
    GrantPermissionsDialog.prototype.render = function () {
        return (React.createElement("div", { "data-tb-test-id": exports.GRANT_ACCESS_TESTID },
            this.renderContents(),
            this.renderFooter()));
    };
    return GrantPermissionsDialog;
}(React.Component));
exports.GrantPermissionsDialog = GrantPermissionsDialog;
//# sourceMappingURL=GrantPermissionsDialog.js.map